import React from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import BackIcon from "../../assets/images/dasboard/chevronright.webp";
import secureLocalStorage from "react-secure-storage";
import { useGoToPage } from "../../function/functions";

// get base_url
const { protocol, hostname, port } = window.location;
const portPart = port ? `:${port}` : ""; // Include port if it exists
const fullURL = `${protocol}//${hostname}${portPart}`;

const menuOption = [
  {
    name: "Settings",
    key: 31,
    subtitle: "Change your preferences",
    src: fullURL + "/images/deshboard/setting.webp",
  },
  {
    name: "Subscription",
    key: 32,
    subtitle: "Upgrade or downgrade your plan",
    src: fullURL + "/images/deshboard/subcribe.webp",
  },
  // {
  //   name: "Good read !",
  //   key: 33,
  //   subtitle: "Health related topics & videos",
  //   src: fullURL + "/images/deshboard/chat.webp",
  // },
  {
    name: "Help center",
    key: 34,
    subtitle: "Feature request or general feedback",
    src: fullURL + "/images/deshboard/emai.webp",
  },
  {
    name: "About FastBetter",
    key: 35,
    subtitle: "Terms, privacy and disclaimers",
    src: fullURL + "/images/deshboard/star.webp",
  },
];
export default function Menu() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const age_val = profileDetails?.surveyItems[4]?.categoryItems[0].isVal;
  const height_cm = profileDetails?.surveyItems[1]?.categoryItems[2].isVal;
  const height_ft = profileDetails?.surveyItems[1]?.categoryItems[0].isVal;
  const height_inch = profileDetails?.surveyItems[1]?.categoryItems[1].isVal;
  const dispatch = useDispatch();
  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    secureLocalStorage.removeItem("backMenu");
    if (menu && menu === 1) {
      secureLocalStorage.setItem("backMenu", "1");
    }
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(null));
    await dispatch(setIsDrawerActive(false));
  };

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="fasweekdes mb-5 mx-3">
        <div className="mode1">
          <img
            loading="lazy"
            src={`${profileDetails?.image}`}
            className="w-10 rounded-sm"
            alt="useryou"
          />
          <div className="tabroe">
            <div className="modetit text-capitalize">
              {profileDetails?.name}
            </div>
            {/* <div className="modesutit">Basic TRF (16:8)</div> */}
          </div>
        </div>
        <div
          className="plusbox cursor-pointer"
          onClick={() => handleChangeSidebar(1)}
        >
          <img loading="lazy" src={BackIcon} alt="spluse" />
        </div>
      </div>
      <div className="fasweekdes  mx-3">
        <div className="flex gap-2">
          <div className="tabroe border-r border-gray-400 pr-2">
            <div className="modesutit text-xs">Registered Weight</div>
            <div className="tabetsbol font-semibold text-xs">
              {profileDetails?.summary?.currentWeight +
                " " +
                profileDetails?.summary?.weightType}
            </div>
          </div>
          <div className="tabroe">
            <div className="modesutit text-xs">Target weight</div>
            <div className="tabetsbol font-semibold text-xs">
              {profileDetails?.summary?.targetWeight +
                " " +
                profileDetails?.summary?.weightType}
            </div>
          </div>
        </div>
        <div className="tabroe text-right">
          <div className="modesutit text-xs">Age</div>
          <div className="tabetsbol font-semibold text-xs">
            {age_val + " Years "}
          </div>
        </div>
      </div>
      <div className="fasweekdes  mx-3">
        <div className="tabroe">
          <img
            loading="lazy"
            src={fullURL + "/images/deshboard/line.webp"}
            alt="line"
            className="linimg"
          />
          <div style={{ textAlign: "right" }}>
            <p className="modesutittex font-medium text-xs">
              Target in {profileDetails?.summary?.nextMonth} :{" "}
              <span className="tabetsbol font-bold text-xs">
                {profileDetails?.summary?.nextMonthTargetWeight +
                  " " +
                  profileDetails?.summary?.weightType}{" "}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 mt-6 w-10/12 mx-auto pb-14">
        {menuOption.map((item, index) => (
          <div
            key={item.key}
            className={`fasweekdes sidemenubox ${index === 1 && "mb-10"}`}
          >
            <div className="mode1">
              <div>
                <img loading="lazy" src={item.src} alt={item.name} />
              </div>
              <div className="tabroe">
                <div className="sidetest text-base leading-snug">
                  {item.name}
                </div>
                <div className="modesutittex text-gray-500 text-[11px]">
                  {item.subtitle}
                </div>
              </div>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => {
                item.key === 33
                  ? (window.location.href = "/good-read")
                  : handleChangeSidebar(item.key);
              }}
            >
              <div className="sidearro">
                <img
                  loading="lazy"
                  src={fullURL + "/images/deshboard/chevron.webp"}
                  alt="chevron"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
